import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef } from '@angular/core';

import { SAMService } from '../../../sam/sam.service';
import { SAMMessage } from 'src/app/sam/interfaces/sam-message';
import { SpeechService } from 'src/app/services/speech.service';
import { SoundService } from 'src/app/services/sound.service';
import { ConfigService } from 'src/app/config.service';
import { ThemeService } from 'ngx-elvis-ds';
import { BasePage } from 'ngx-elvis-ds';
import { I18NService } from '../../../services/i18n.service';

export class OverlayDialogCommands {
  public static OPEN = ['OVERLAY_DIALOG_OPEN'];
  public static UPDATE = ['OVERLAY_DIALOG_UPDATE'];
  public static CLOSE = ['OVERLAY_DIALOG_CLOSE'];
}

@Component({
  selector: 'app-overlay-dialog',
  templateUrl: './overlay-dialog.page.html',
  styleUrls: ['./overlay-dialog.page.scss'],
})
export class OverlayDialogPage extends BasePage implements OnInit, OnDestroy {
  @ViewChild('dialog', { static: true }) overlayDialog: ElementRef;
  @Input() data: any = {};

  constructor(
    private sam: SAMService,
    public themeSvc: ThemeService,
    public configSvc: ConfigService,
    private speechSvc: SpeechService,
    private soundSvc: SoundService,
    public i18nSvc: I18NService
  ) {
    super();
    this.subscribeListeners();
  }

  onCallback() {
    const response = {
      Command: 'GENERIC_INPUT',
      Callback: this.data.Callback || 'OK',
      parms: {},
    };

    if (this.data.Callback === 'CMD_SET_TUTORIAL_SEEN') {
      response.parms = { TutorialID: this.data.CallbackData };
    }

    this.sam.onSend(response);
  }

  ngOnInit() {
    if (this.data.Speech) {
      this.speechSvc.say(this.data.Speech);
    }

    if (this.data.Sound) {
      this.soundSvc.play(this.data.Sound);
    }

    if (this.data.Image === 'wallet') {
      if (
        this.configSvc.hardwareSettings.cash &&
        this.configSvc.hardwareSettings.cash.position &&
        this.configSvc.hardwareSettings.cash.position.z
      ) {
        this.overlayDialog.nativeElement.style.setProperty(
          '--arrow-rotation',
          `${this.configSvc.hardwareSettings.cash.position.z}deg`
        );
      }
    }

    if (this.data.Image === 'credit-card') {
      if (
        this.configSvc.hardwareSettings.eft &&
        this.configSvc.hardwareSettings.eft.position &&
        this.configSvc.hardwareSettings.eft.position.z
      ) {
        this.overlayDialog.nativeElement.style.setProperty(
          '--arrow-rotation',
          `${this.configSvc.hardwareSettings.eft.position.z}deg`
        );
      }
    }
  }

  ngOnDestroy() {
    if (this.subscriptions.modalEventsListener) {
      this.subscriptions.modalEventsListener.unsubscribe();
    }
  }

  // private

  private subscribeListeners() {
    this.subscriptions.modalEventsListener =
      this.sam.channels.dialogs.subscribe((msg: SAMMessage) => {
        if (OverlayDialogCommands.UPDATE.includes(msg.Command)) {
          if (this.data.Speech !== msg.parms.Speech) {
            this.speechSvc.say(msg.parms.Speech);
          }

          if (this.data.Sound !== msg.parms.Sound) {
            this.soundSvc.play(msg.parms.Sound);
          }

          this.data = msg.parms as any;
        }
      });
  }
}
